import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { StarMotif } from "./StarMotif";

export function CTABlock({
    title,
    description,
    primaryLabel,
    primaryTo,
    secondaryLabel,
    secondaryTo,
}) {
    const t = title || "Have a project in mind?";
    const d = description || "Talk to a principal engineer this week. No sales gauntlet — just an honest conversation about your outcomes and timelines.";
    const pl = primaryLabel || "Schedule a Meeting";
    const pt = primaryTo || "/schedule-meeting";
    const sl = secondaryLabel || "Request a Quote";
    const st = secondaryTo || "/request-quote";
    return (
        <section className="relative overflow-hidden bg-[hsl(222_47%_7%)] text-white" data-testid="cta-block">
            <div className="absolute -right-16 -top-16 h-96 w-96 opacity-10">
                <StarMotif className="h-full w-full text-primary" label="RKS" labelColor="currentColor" />
            </div>
            <div className="absolute inset-0 grid-lines opacity-40" />
            <div className="container-app relative py-20 lg:py-24">
                <div className="grid gap-10 lg:grid-cols-[1fr,auto] lg:items-center">
                    <div className="max-w-2xl">
                        <span className="overline text-primary/90">Next step</span>
                        <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
                            {t}
                        </h2>
                        <p className="mt-5 text-base sm:text-lg text-white/70 leading-relaxed">
                            {d}
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
                        <Link
                            to={pt}
                            data-testid="cta-primary-button"
                            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary px-6 py-3.5 font-semibold text-white btn-lift hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-[hsl(222_47%_7%)]"
                        >
                            {pl}
                            <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
                        </Link>
                        <Link
                            to={st}
                            data-testid="cta-secondary-button"
                            className="inline-flex items-center justify-center gap-2 rounded-md border border-white/20 bg-white/5 px-6 py-3.5 font-semibold text-white btn-lift hover:bg-white/10 hover:border-white/40"
                        >
                            {sl}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CTABlock;
